module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#1E88E5","theme_color":"#1E88E5","display":"minimal-ui","icon":"src/images/ideker_favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"861facb6182c59c83ee61809b53fc320"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
